import {
  getGameBasicinfo as getGameBasicinfoCommon,
  getGameBasicinfoCombine as getGameBasicinfoCombineOriginal,
} from '@/pages/intelligence/services/topcharts';
import { analysisPlatformsBasicByString } from '@intelligence/utils/topchartsUtils';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { COMBINEID_REG } from '@intelligence/utils/constant';

import type { IGameType } from '@intelligence/types/common';

export const createGameBasicinfoFetcher = (
  entityType: IGameType,
): ((payload: any) => Promise<any>) => {
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE)
    return async (subPayload) => {
      // 添加融合ID校验规则
      if (COMBINEID_REG.test(subPayload?.id)) {
        const subPayloadTmp = {
          entity_type: subPayload?.entity_type || 'combine',
          id:  subPayload?.id || subPayload?.entity_id || '',
          about: subPayload?.about || 0,
          similar_game: subPayload?.similar_game || 0,
        };
        const res = await getGameBasicinfoCombineOriginal(subPayloadTmp);
        return {
          ...res,
          data: {
            ...res?.data,
            basic_info: {
              ...res?.data?.basic_info,
              platforms: analysisPlatformsBasicByString(res?.data?.basic_info?.platform),
            },
          },
        };
      }
      return {};
    };

  return (subPayload) => {
    const subPayloadTmp = { ...subPayload };
    delete subPayloadTmp.about;
    delete subPayloadTmp.similar_game;
    // 添加融合ID校验规则
    if (COMBINEID_REG.test(subPayloadTmp?.id)) {
      return getGameBasicinfoCommon(subPayloadTmp);
    }
  };
};
